import { editFuelSurcharge } from ".";

interface RequestParameters {
  updatedItem: any;
  fetchData: any,
  setEditIndex: any,
  enqueueSnackbar: any,
  setLoading: any,
}

export default function editData({
  updatedItem,
  fetchData,
  setEditIndex,
  enqueueSnackbar,
  setLoading,
}: RequestParameters) {
  setLoading(true);
  editFuelSurcharge(updatedItem)
    .then((response: any) => {
      if (!response.data.is_error) {
      enqueueSnackbar('Fuel Surcharge has been updated.', {
        variant: 'success',
      });
      fetchData();
      setEditIndex('');
    }
  })
  .catch((e: any) => {
    enqueueSnackbar('Error updating Fuel Surcharge.', { variant: 'error' });
  })
  .finally(() => {
    setLoading(false);
  });
}
